/**
 * API client for Dead Letter Queue endpoints
 */

import { apiClient } from './client';

export interface DLQItem {
  id: string;
  order_id: string;
  task_name: string;
  error_message: string;
  retry_count: number;
  failed_at: string;
  last_state: Record<string, any> | null;
}

export interface DLQItemDetail extends DLQItem {
  task_args: Record<string, any>;
  stack_trace: string | null;
  resolved_at: string | null;
  resolved_by: string | null;
  metadata: Record<string, any> | null;
}

export interface DLQListParams {
  page?: number;
  per_page?: number;
}

export const dlqApi = {
  /**
   * Get paginated list of unresolved DLQ items
   */
  async getList(params: DLQListParams = {}) {
    const response = await apiClient.get('/admin/dlq/', { params });
    return response.data;
  },

  /**
   * Get DLQ item details
   */
  async getDetail(dlqId: string): Promise<DLQItemDetail> {
    const response = await apiClient.get(`/admin/dlq/${dlqId}`);
    return response.data;
  },

  /**
   * Retry failed task
   */
  async retry(dlqId: string): Promise<{
    success: boolean;
    task_id?: string;
    task_name?: string;
    error?: string;
  }> {
    const response = await apiClient.post(`/admin/dlq/${dlqId}/retry`);
    return response.data;
  },

  /**
   * Dismiss DLQ item without retrying
   */
  async dismiss(dlqId: string): Promise<{
    success: boolean;
    dlq_id?: string;
    resolved_by?: string;
    error?: string;
  }> {
    const response = await apiClient.post(`/admin/dlq/${dlqId}/dismiss`);
    return response.data;
  },
};
